import { v4 as uuidv4 } from 'uuid';
import { DOCUMENT_CATEGORY, DOCUMENT_TYPE, PAYMASTER_DOCUMENT_TYPE } from '../constant';
const documentTypesFakeData = () => [{
  code: DOCUMENT_TYPE.RFA,
  label: 'Request for approval',
  description: null,
  category: DOCUMENT_CATEGORY.SIGNATURE,
  weight: 0
}, {
  code: DOCUMENT_TYPE.FR_REG,
  label: 'Justificatif d\'immatriculation',
  description: '(Kbis ou extrait de l’inscription au répertoire des métiers de moins de 3 mois)',
  category: DOCUMENT_CATEGORY.MANDATORY,
  weight: 100
}, {
  code: DOCUMENT_TYPE.FR_COV,
  label: 'Attestation de vigilance',
  description: '(URSSAF conforme au décret du 21/11/2011, MSA, RSI de moins de 6 mois)',
  category: DOCUMENT_CATEGORY.MANDATORY,
  weight: 200
}, {
  code: DOCUMENT_TYPE.FOREIGN_EMPLOYEES,
  label: 'Liste des salariés étrangers soumis à autorisation de travail',
  description: '(conforme à l’article D 8254-2 du code du travail)',
  category: DOCUMENT_CATEGORY.MANDATORY,
  weight: 300
}, {
  code: DOCUMENT_TYPE.INS_RC_PRO,
  label: 'Assurance RC Professionnelle',
  description: 'en cours de validité',
  category: DOCUMENT_CATEGORY.OPTIONAL,
  weight: 400
}, {
  code: DOCUMENT_TYPE.FR_INS_DEC,
  label: 'Attestation Décennale Standard',
  description: 'en cours de validité',
  category: DOCUMENT_CATEGORY.OPTIONAL,
  weight: 500
}, {
  code: DOCUMENT_TYPE.FR_TAX,
  label: 'Attestation fiscale',
  description: 'en cours de validité',
  category: DOCUMENT_CATEGORY.OPTIONAL,
  weight: 600
}, {
  code: DOCUMENT_TYPE.FR_PAY,
  label: 'Attestation Congés payés',
  description: 'en cours de validité',
  category: DOCUMENT_CATEGORY.OPTIONAL,
  weight: 700
}, {
  code: DOCUMENT_TYPE.FR_QUALIF_CERTIF,
  label: 'Qualifications ou Capacités de l\'entreprise',
  description: 'en cours de validité',
  category: DOCUMENT_CATEGORY.OPTIONAL,
  weight: 800
}, {
  code: DOCUMENT_TYPE.EMP_STAFF,
  label: 'Liste du personnel	',
  description: 'en cours de validité',
  category: DOCUMENT_CATEGORY.OPTIONAL,
  weight: 900
}, {
  code: DOCUMENT_TYPE.ADD_RIB,
  label: 'RIB',
  description: null,
  category: DOCUMENT_CATEGORY.OPTIONAL,
  weight: 1000
}, {
  code: DOCUMENT_TYPE.ADD_SWORN_STAT,
  label: 'Attestation sur l’honneur	',
  description: 'en cours de validité',
  category: DOCUMENT_CATEGORY.OPTIONAL,
  weight: 1100
}, {
  code: PAYMASTER_DOCUMENT_TYPE.RFA_OWNER,
  label: 'Caution bancaire',
  description: null,
  category: DOCUMENT_CATEGORY.SPECIFIC,
  weight: 1200
}, {
  code: PAYMASTER_DOCUMENT_TYPE.CLIENT,
  label: 'Délégation de paiement',
  description: null,
  category: DOCUMENT_CATEGORY.SPECIFIC,
  weight: 1300
}, {
  code: DOCUMENT_TYPE.ADD_SUBCONTRACTING_K,
  label: 'Contrat de sous-traitance',
  description: null,
  category: DOCUMENT_CATEGORY.SPECIFIC,
  weight: 1400
}];
const customDocumentTypesFakeData = [createFakeCustomDocumentType({
  label: 'Attestation Retraite',
  weight: 100000
}), createFakeCustomDocumentType({
  label: 'Attestation Prévoyance',
  weight: 100100
})];
export function createFakeCustomDocumentType() {
  let {
    code = uuidv4(),
    label = '',
    weight = 100000,
    ...rest
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    category: DOCUMENT_CATEGORY.CUSTOM,
    description: null,
    code,
    label,
    weight,
    ...rest
  };
}
export const getDocumentTypes = () => documentTypesFakeData();
export const getDocumentTypesFiltered = predicate => documentTypesFakeData().filter(predicate);
export const getCustomDocumentTypes = () => customDocumentTypesFakeData;
export const getFullDocumentTypes = () => documentTypesFakeData().concat(customDocumentTypesFakeData);
export const getFullDocumentTypesFiltered = predicate => documentTypesFakeData().concat(customDocumentTypesFakeData).filter(predicate);
export const findDocumentType = code => Object.assign({}, documentTypesFakeData().find(documentType => documentType.code === code));
export const findCustomDocumentType = code => Object.assign({}, customDocumentTypesFakeData.find(documentType => documentType.code === code));